<template>
  <v-img max-width="112px" src="@/assets/logo.webp" contain />
</template>

<script>
  import ComponentMixin from "../ComponentMixin";

  export default {
    mixins: [ComponentMixin],
    type: "atom",
    name: "ConnectLogo",
  }
</script>

<style scoped lang="sass">
.beta
  color: #2f3e6d
  font-weight: bold
  min-width: 36.5 px
</style>
